export const currentUserActionTypes = {
  STORE_USER_DETAILS: "STORE_USER_DETAILS",
  STORE_FACILITY_WORKER_DETAILS: "STORE_FACILITY_WORKER_DETAILS",
};
